export default "__VITE_ASSET__3de6fc50__"